// product-form-new.js
export default (Alpine) => {
    Alpine.data("recommendedMerch", ({ productId, variantId }) => ({
		productId,
		variantId,
        options:[],
        currentVariant: null,
		sellingPlan: null,
		deliveryOptions: false,
		quantity: 1,
		jsLoaded: false,
		isMerch: false,
		optionSelects: {},
		productTitle: null,


        init() {
			this.jsLoaded = true;

			const variantObject = this.$el.querySelector('.variant-object-recs').textContent.trim();
			this.variants = Object.values(JSON.parse(variantObject));
			this.currentVariant = this.variants.find(variant => String(variant.id) === String(this.variantId));
			const optionContainer = this.$el.querySelector('[option-container]');
			this.productTitle = this.currentVariant.product_title;

			if (!optionContainer) {
				return;
			}

			optionContainer.querySelectorAll('select.option-select').forEach((select, index) => {
				this.optionSelects[`option${index + 1}`] = {
					select: select,
					open: false,
					image: this.currentVariant.image,
				};
			});

			if (!this.currentVariant) {
				this.currentVariant = this.variants[0];
			}

        },

		toggle(optionIndex) {
			if (this.optionSelects[`option${optionIndex}`].open) {
				setTimeout(() => {
					return this.close(optionIndex)
				}, 100);
			}

			this.optionSelects[`option${optionIndex}`].select.focus()

			this.optionSelects[`option${optionIndex}`].open = true
		},

		close(optionIndex) {
			if (! this.optionSelects[`option${optionIndex}`].open) return

			setTimeout(() => {
				this.optionSelects[`option${optionIndex}`].open = false
			}, 100);

			this.optionSelects[`option${optionIndex}`].select.focus()
		},

		onKeyDown(event) {
			const options = Array.from(this.optionSelects[`option${optionIndex}`].select.querySelectorAll('[role="option"]'));
			const current = event.currentTarget;
			const index = options.indexOf(current);
			const next = options[index + 1] || options[0]; // wrap to first
			next.focus();
		  },
		  
		  onKeyUp(event) {
			const options = Array.from(this.optionSelects[`option${optionIndex}`].select.querySelectorAll('[role="option"]'));
			const current = event.currentTarget;
			const index = options.indexOf(current);
			const prev = options[index - 1] || options[options.length - 1]; // wrap to last
			prev.focus();
		  },

		  openAndFocusOption() {
			if (!this.optionSelects[`option${optionIndex}`].open) {
			  this.optionSelects[`option${optionIndex}`].open = true;
			}
		  
			this.$nextTick(() => {
			  const selected =
				this.optionSelects[`option${optionIndex}`].select.querySelector('[aria-selected="true"]') ||
				this.optionSelects[`option${optionIndex}`].select.querySelector('[role="option"]');
		  
			  if (selected) {
				selected.focus();
			  }
			});
		  },
		  
        onVariantChange(optionIndex, e) {
			let options = [];

			const optionWrapper = e.target.closest('[option-container]');

			options = Array.from(optionWrapper.querySelectorAll('select.option-select'));
			this.options = options.map((option) => option.value);

			this.getCurrentVariant(optionIndex, e);

			const variantChanged = new CustomEvent('variant-changed', {
				detail: { variant: this.currentVariant },
				bubbles: true,
			})

			this.optionSelects[`option${optionIndex}`].image = this.currentVariant.image;

			// Dispatch event to tell the product gallery to update the variant images
			// product-gallery-v2.js
			document.dispatchEvent(variantChanged)

			this.close(optionIndex);
        },


		rebuildOptions(el) {

			let allOptions = {
				"option1": [],
				"option2": [],
				"option3": [],
			};

			this.variants.forEach(variant => {
				variant.options.forEach((option, index) => {
					if (!allOptions[`option${index + 1}`].includes(option)) {
						allOptions[`option${index + 1}`].push(option);
					}
				});
			});

			let availableOptions = {
				option1: [],
				option2: [],
				option3: [],
			}

			availableOptions.option1 = allOptions.option1
			availableOptions.option2 = allOptions.option2.filter(option => this.variants.some(variant => variant.option1 === this.currentVariant.option1 && variant.option2 === option));
			availableOptions.option3 = allOptions.option3.filter(option => this.variants.some(variant => variant.option1 === this.currentVariant.option1 && variant.option2 === this.currentVariant.option2 && variant.option3 === option));

			el.querySelectorAll('product-recommendations label.select-label').forEach(label => {
			    const optionLabel = label
			    const attrName = optionLabel?.getAttribute('name');
			    if (attrName === 'select-option1') {
			        optionLabel.setAttribute('for', this.productTitle + ' ' + this.currentVariant.option1);
			        optionLabel.innerHTML = this.currentVariant.option1;
			    }
			    if (attrName === 'select-option2') {
			        optionLabel.setAttribute('for', this.productTitle + ' ' + this.currentVariant.option2);
			        optionLabel.innerHTML = this.currentVariant.option2;
			    }
			});
			el.querySelectorAll('product-recommendations select.option-select').forEach(select => {
				const optionSelect = select
				const optionIndex = optionSelect.name.split('select-option')[1];
				const attrName = optionSelect?.getAttribute('name');

				optionSelect.innerHTML = '';
				if (optionSelect.hasAttribute('data-flavor')) {
					optionSelect.setAttribute('data-flavor', this.currentVariant.option1);
				}
				if (optionSelect.hasAttribute('id')) {
				    if (attrName === 'select-option1') {
				        optionSelect.setAttribute('id', this.productTitle + ' ' + this.currentVariant.option1);
				    }
				    if (attrName === 'select-option2') {
				        optionSelect.setAttribute('id', this.productTitle + ' ' + this.currentVariant.option2);
				    }
				}
				availableOptions[`option${optionIndex}`].forEach(option => {
					const optionOption = document.createElement('option');
					optionOption.value = option;
					optionOption.text = option;
					optionSelect.add(optionOption);
					if (option === this.currentVariant[`option${optionIndex}`]) {
						optionSelect.value = option;
					}
				});
			});
		},
		  
        getCurrentVariant(optionIndex, e) {
			let variant = null;
			if (e.currentTarget.hasAttribute('data-flavor-option')) {
				// Custom flavor selector dropdown
				variant = this.variants.find((variant) => {
					return variant.option1 === e.currentTarget.dataset.value;
				});
			} else {
				// Standard selector dropdown
				variant = this.variants.find((variant) => {
					if (optionIndex === 1) {
						return variant.option1 === e.currentTarget.dataset.value && variant.option2 === this.currentVariant.option2 && variant.option3 === this.currentVariant.option3;
					} else if (optionIndex === 2) {
						return variant.option1 === this.currentVariant.option1 && variant.option2 === e.currentTarget.dataset.value && variant.option3 === this.currentVariant.option3;
					} else if (optionIndex === 3) {
						return variant.option1 === this.currentVariant.option1 && variant.option2 === this.currentVariant.option2 && variant.option3 === e.currentTarget.dataset.value;
					}
				});
			}

			// if no variant found, use first option and apply default 2nd and 3rd options
			if (!variant) {
				variant = this.variants.find((variant) => {
					return variant.option1 === this.options[0];
				});
			}

            this.currentVariant = variant;
			this.setAvailability(optionIndex)
		
			this.rebuildOptions(e.target.closest('[option-container]'))
			
        },

		setAvailability(optionIndex) {
			const available = this.currentVariant.available;
			const button = this.$el.closest('form').querySelector('button[type="submit"]');
			const buttonText = button.querySelector('[data-button-text]');

			console.log('button', button);
			console.log('buttonText', buttonText);
			button.toggleAttribute('disabled', !available);
			buttonText.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
		},


        addToCart() {
            const sideCart = document.querySelector('side-cart');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{ id: this.currentVariant.id, selling_plan: this.sellingPlan, quantity: this.quantity }],
                }),
            })
            .then(response => response.json())
            .then(data => {
                Rebuy.SmartCart.show()
            })
            .catch(error => {
                console.error('Error:', error);
            });
        },	
    }));
  };